module.exports = __webpack_public_path__ + "static/media/checkmark-icon--green.2474d5cf.svg";